import { api } from "@/lib/api";
import type { OverviewWindow } from "@/lib/journey-overview-format";

export type OverviewMetrics = {
  pending_confirm: { people: number; batches: number };
  sent_people: number;
  failed: { people: number; batches: number };
  /** 运营作废（error 以「已作废」开头），不计入出站失败 */
  voided?: { people: number; batches: number };
  cancelled?: { people: number; batches: number };
  new_contacts: number;
  churned_contacts: number;
  next_slot: {
    slot_key: string;
    people: number;
    label: string;
    at?: string;
  };
};

export type OverviewBatch = {
  id: string;
  day: string;
  slot_key: string;
  journey_definition_id: number | null;
  journey_name: string;
  cohort_label: string;
  people_count: number;
  external_userids: string[];
  status: string;
  dirty_draft: boolean;
  reason_code: string | null;
  reason_summary: string | null;
  journey_plan_step_id: number | null;
  journey_customer_binding_id: number | null;
  msgid: string | null;
  sender_userid?: string | null;
  content_preview: string;
};

export type OverviewBoardCard = OverviewBatch & {
  planned_on?: string;
};

export type JourneyOverviewPayload = {
  window: OverviewWindow | string;
  ops_date: string;
  chart_from: string;
  chart_to: string;
  metrics: OverviewMetrics;
  series: {
    days: string[];
    sent_people: number[];
    new_contacts: number[];
    churned_contacts: number[];
    by_journey: Array<{
      journey_definition_id: number;
      name: string;
      sent_people: number[];
    }>;
  };
  board: {
    pending_confirm: OverviewBatch[];
    upcoming: Array<{
      id: string;
      journey_definition_id: number;
      journey_name: string;
      slot_key: string;
      people_count: number;
      external_userids: string[];
      planned_on?: string;
    }>;
    needs_action: OverviewBatch[];
  };
  batches: OverviewBatch[];
};

export async function fetchJourneyOverview(
  accountId: string | number,
  opts: {
    brandId: string | number;
    window?: OverviewWindow;
    from?: string;
    to?: string;
  },
): Promise<JourneyOverviewPayload> {
  const params = new URLSearchParams({
    brand_id: String(opts.brandId),
  });
  if (opts.window) params.set("window", opts.window);
  if (opts.from) params.set("from", opts.from);
  if (opts.to) params.set("to", opts.to);
  return api.fetchForAccount<JourneyOverviewPayload>(
    accountId,
    `/account/journey_overview?${params.toString()}`,
  );
}
